// extracted by mini-css-extract-plugin
export default {"linkWrap":"ForgotPassword_linkWrap__fqYOR","inputError":"ForgotPassword_inputError__0Kdkv"};